import { yawFromRosOrientation } from "lib/protocols/mapFilterYaml";
import { DummyServiceResponses } from "arcjs/services/sources/dummy";
import { Mission } from "arcjs/common/navigation";
import { Pose } from "arcjs/common/geometry";
import { SERVICE_GET_MISSION, SERVICE_LIST_MISSIONS } from "arcjs/state";
import { SPOT_LIGHT_SERVICE } from "lib/protocols/spotLight";
import { SECURITY_MODULE_SERVICE } from "lib/protocols/securityModule";
import { E_STOP_SET_SERVICE } from "lib/protocols/estop";
import { Fleet } from "types/fleet";
import { ARCInfo } from "arcjs/common/arc_devices";

export const IS_DEV = process.env.REACT_APP_IS_DEV === "true" ? true : false;

export const USE_DUMMY = (IS_DEV && process.env.REACT_APP_USE_DUMMY === "true") ?? false;

console.log('IS_DEV, USE_DUMMY', IS_DEV, USE_DUMMY)

export const genDummyStatus = () => ({
    timestamp: 1706022000000,
    batteryLevel: 69,
    networkType: "5G",
    geolocation: { lat: 22.3365227, long: 114.1979563 },
    online: Math.floor(Math.random() * 100) % 2 === 0,
    robot: {
        networkType: "Eth",
        batteryLevel: 87,
    },
});

export const ROBOTS_TO_CHANGE = [
    {
        serialNumber: "GO1_1000",
        name: "Go1 1000",
        type: "GO1",
    },
    {
        serialNumber: "SPOT-DB-123456789",
        name: "SPOT 123456789",
        type: "SPOT",
    },
];

export const ROBOT_CHANGING_ARC = "AC-1000";

export const DUMMY_ARCS_INFO: ARCInfo[] = [
    {
        serialNumber: "DUMMY",

        payload: "DUMMY",

        // Connection
        host: "DUMMY",

        // Control
        controlSource: "DUMMY",

        // Robot
        robot: { serialNumber: "DUMMY_ROBOT_1", name: "Dummy robot", type: "DUMMY_ROBOT" },
    },
    {
        // get from fleet management data / local discovery
        serialNumber: ROBOT_CHANGING_ARC,
        controlSource: "ROSLIBJS",
        host: "192.168.2.13",

        // inferred from fleet management data + real-time update

        // get by endpoint-discovery

        // get by network discovery

        // get by real-time update

        payload: "PTZ Payload",

        // get by network stats

        // inverse coefficient of latency

        robot: {
            serialNumber: "SPOT-DB-123456789",
            name: "SPOT-DB-123456789",
            type: "SPOT",
        },
    },
    {
        serialNumber: "AC-0002",
        controlSource: "ROSLIBJS",
        host: "192.168.2.13",

        payload: "PTZ Payload",

        robot: {
            serialNumber: "SPOT-DB-123456789",
            name: "SPOT-DB-123456789",
            type: "SPOT",
        },
    },
    {
        serialNumber: "AC-0003",
        controlSource: "ROSLIBJS",

        payload: "PTZ Payload",
        host: "192.168.2.13",

        robot: {
            serialNumber: "SPOT-DB-123456789",
            name: "SPOT-DB-123456789",
            type: "SPOT",
        },
    },
    {
        serialNumber: "AC-0004",
        controlSource: "ROSLIBJS",

        payload: "PTZ Payload",

        host: "192.168.2.13",
        robot: {
            serialNumber: "SPOT-DB-123456789",
            name: "SPOT-DB-123456789",
            type: "SPOT",
        },
    },
    {
        serialNumber: "AC-0005",
        controlSource: "ROSLIBJS",
        host: "192.168.2.113",

        payload: "PTZ Payload",

        robot: {
            serialNumber: "SPOT-DB-123456789",
            name: "SPOT-DB-123456789",
            type: "SPOT",
        },
    },
    {
        serialNumber: "AC-0006",
        controlSource: "ROSLIBJS",
        host: "192.168.2.113",

        payload: "PTZ Payload",

        robot: {
            serialNumber: "SPOT-DB-123456789",
            name: "SPOT-DB-123456789",
            type: "SPOT",
        },
    },
    {
        serialNumber: "AC-0007",
        controlSource: "ROSLIBJS",
        host: "192.168.2.113",

        payload: "PTZ Payload",

        robot: {
            serialNumber: "SPOT-DB-123456789",
            name: "SPOT-DB-123456789",
            type: "SPOT",
        },
    },
    {
        serialNumber: "AC-0008",
        controlSource: "ROSLIBJS",

        payload: "PTZ Payload",
        host: "192.168.2.113",

        robot: {
            serialNumber: "SPOT-DB-123456789",
            name: "SPOT-DB-123456789",
            type: "SPOT",
        },
    },
    {
        serialNumber: "AC-0009",
        controlSource: "ROSLIBJS",

        payload: "PTZ Payload",
        host: "192.168.2.113",

        robot: {
            serialNumber: "SPOT-DB-123456789",
            name: "SPOT-DB-123456789",
            type: "SPOT",
        },
    },
    {
        serialNumber: "AC-0010",
        controlSource: "ROSLIBJS",

        payload: "PTZ Payload",
        host: "192.168.2.113",

        robot: {
            serialNumber: "SPOT-DB-123456789",
            name: "SPOT-DB-123456789",
            type: "SPOT",
        },
    },
];

export const DEFAULT_POSE: Pose = {
    orientation: { x: 0, y: 0, z: 0, w: 1 },
    position: { x: 0, y: 0, z: 0 },
};

export const DUMMY_MISSIONS: Mission[] = [
    {
        id: "mission_1",
        name: "Mission 1",
        created_time: "2024-05-01T13:12:59Z",
        waypoints: [
            {
                id: "waypoint_1",
                map_id: "map_1",
                name: "Waypoint 1",
                pose: DEFAULT_POSE,
                type: "waypoint",
                created_time: 0,
            },
        ],
    },
];

export const DUMMY_SERVICE_RESPONSES: DummyServiceResponses = {
    callCustomActionService: [],
    callService: {
        [SERVICE_LIST_MISSIONS]: {
            resFn: () => {
                return { missions: DUMMY_MISSIONS } as { missions: Mission[] };
            },
        },
        [SERVICE_GET_MISSION]: {
            resFn: ({ mission_id }: { mission_id: string }) => {
                const mission = DUMMY_MISSIONS.find((m) => m.id === mission_id);
                if (!mission) {
                    throw new Error("Mission not found");
                }
                return mission;
            },
        },
        [SPOT_LIGHT_SERVICE]: {
            resFn: () => ({
                success: true,
                message: "ok",
                hardware_command_json: JSON.stringify({
                    schema: "hardware_command_v1",
                    spot_light: { on: 0, brightness_percent: 0 },
                }),
            }),
        },
        [SECURITY_MODULE_SERVICE]: {
            resFn: () => ({
                success: true,
                message: "ok",
                security_command_json: JSON.stringify({
                    schema: "security_module_command_v1",
                    power: { spotlight: 0, flash: 0 },
                }),
            }),
        },
        [E_STOP_SET_SERVICE]: {
            resFn: () => ({
                success: true,
                message: "",
            }),
        },
    },
    callSpotService: [],
};

export const DUMMY_FLEETS_INFO: Fleet[] = [
    {
        id: "fleet_id_spk",
        fleetName: "Fleet @ SPK",
        arcs: DUMMY_ARCS_INFO,
        mapId: "map_1",
    },
    {
        id: "fleet_id_stp",
        fleetName: "Fleet @ STP",
        arcs: DUMMY_ARCS_INFO,
        mapId: "map_1",
    },
];

export const DUMMY_MISSION_LOGS_INFO = [
    {
        id: "1",
        date: "2023-03-31",
        time: "20:16:11",
        mission: "5F Patrol",
        map: "map1",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "2",
        date: "2023-03-01",
        time: "20:17:11",
        mission: "5F Patrol",
        map: "map1",
        arc: "AC-0002",
        robot: "Spot-2",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "3",
        date: "2023-03-10",
        time: "20:15:11",
        mission: "5F Patrol",
        map: "n9",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "4",
        date: "2023-03-11",
        time: "20:18:11",
        mission: "5F Patrol",
        map: "map1",
        arc: "AC-0002",
        robot: "Spot-2",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "5",
        date: "2023-03-12",
        time: "20:13:11",
        mission: "5F Patrol",
        map: "map1",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "6",
        date: "2023-03-12",
        time: "20:12:11",
        mission: "5F Patrol",
        map: "map3",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "7",
        date: "2023-03-12",
        time: "20:11:11",
        mission: "5F Patrol",
        map: "map4",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "8",
        date: "2023-03-12",
        time: "20:19:11",
        mission: "6F Patrol",
        map: "map1",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "9",
        date: "2023-03-12",
        time: "20:26:11",
        mission: "7F Patrol",
        map: "map5",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "10",
        date: "2023-03-12",
        time: "20:06:11",
        mission: "7F Patrol",
        map: "map1",
        arc: "AC-0001",
        robot: "Spot-2",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "11",
        date: "2023-03-12",
        time: "20:05:11",
        mission: "5F Patrol",
        map: "map3",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "12",
        date: "2023-03-12",
        time: "20:59:11",
        mission: "5F Patrol",
        map: "map6",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "13",
        date: "2023-03-12",
        time: "20:16:11",
        mission: "5F Patrol",
        map: "map6",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "14",
        date: "2023-03-12",
        time: "20:16:11",
        mission: "6F Patrol",
        map: "map6",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "15",
        date: "2023-03-12",
        time: "20:16:11",
        mission: "5F Patrol",
        map: "map6",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "16",
        date: "2023-03-12",
        time: "20:16:11",
        mission: "5F Patrol",
        map: "map6",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "17",
        date: "2023-03-12",
        time: "20:16:11",
        mission: "5F Patrol",
        map: "map6",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "18",
        date: "2023-03-12",
        time: "20:16:11",
        mission: "5F Patrol",
        map: "map6",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "19",
        date: "2023-03-12",
        time: "20:16:11",
        mission: "5F Patrol",
        map: "map6",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
    {
        id: "20",
        date: "2023-03-12",
        time: "20:16:11",
        mission: "5F Patrol",
        map: "map6",
        arc: "AC-0001",
        robot: "Spot-1",
        state: "Finished",
        errors: 2,
        events: [
            {
                timestamp: "2023-03-08 17:16:55",
                event: "Mission Start",
            },
            {
                timestamp: "2023-03-08 17:17:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1a.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:18:55",
                event: "Inspection / Take Reading / IAQ",
                data: {
                    type: "text",
                    result: "TVOC:128.0  PM2.5:25.0  PM10:31.0  CO2:630.0",
                },
            },
            {
                timestamp: "2023-03-08 17:19:55",
                event: "Monitoring / Detected People",
                data: {
                    type: "image",
                    result: "Face1b.jpg",
                },
            },
            {
                timestamp: "2023-03-08 17:20:55",
                event: "Mission End",
            },
        ],
    },
];

export const DUMMY_MAP_INFO = [
    {
        id: 1,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
        landmarks: {
            chargingPoints: [
                {
                    name: "Charging Spot",
                    pose: {
                        position: {
                            x: 0,
                            y: 10,
                            z: 0,
                        },
                        orientation: {
                            x: 0,
                            y: 0,
                            z: 0,
                            w: 0,
                        },
                    },
                },
            ],
            normalPoints: [
                {
                    name: "Reception",
                    pose: {
                        position: {
                            x: 100,
                            y: 0,
                            z: 0,
                        },
                        orientation: {
                            x: 0,
                            y: 0,
                            z: 0,
                            w: 0,
                        },
                    },
                },
                {
                    name: "Pantry",
                    pose: {
                        position: {
                            x: 120,
                            y: 0,
                            z: 0,
                        },
                        orientation: {
                            x: 0,
                            y: 0,
                            z: 0,
                            w: 0,
                        },
                    },
                },
                {
                    name: "Washing Machine",
                    pose: {
                        position: {
                            x: 130,
                            y: 0,
                            z: 0,
                        },
                        orientation: {
                            x: 0,
                            y: 0,
                            z: 0,
                            w: 0,
                        },
                    },
                },
            ],
            waitingPoints: [
                {
                    name: "Office 1",
                    pose: {
                        position: {
                            x: 10,
                            y: 10,
                            z: 0,
                        },
                        orientation: {
                            x: 0,
                            y: 0,
                            z: 0,
                            w: 0,
                        },
                    },
                },
                {
                    name: "Office 2",
                    pose: {
                        position: {
                            x: 11,
                            y: 11,
                            z: 0,
                        },
                        orientation: {
                            x: 0,
                            y: 0,
                            z: 0,
                            w: 0,
                        },
                    },
                },
                {
                    name: "Office 3",
                    pose: {
                        position: {
                            x: 12,
                            y: 12,
                            z: 0,
                        },
                        orientation: {
                            x: 0,
                            y: 0,
                            z: 0,
                            w: 0,
                        },
                    },
                },
            ],
        },
    },
    {
        id: 2,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 3,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 4,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 5,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 6,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 7,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 8,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 9,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 10,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 11,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 12,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 13,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 14,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 15,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 16,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 17,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 18,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 19,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 20,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 21,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 22,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 23,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 24,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 25,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 26,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 27,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 28,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 29,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 30,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 31,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 32,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 33,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 34,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
    {
        id: 35,
        map: "Map 1",
        floor: "1/F",
        location: "San Po Kong",
        lastUpdated: "1/3/2023",
        createDate: "1/2/2023",
    },
];

export const DUMMY_MAP_IMAGE = "data:image/jpeg;base64,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"

const DUMMY_OCCUPANCY_GRID_MSG = { "header": { "stamp": { "sec": 1763531046, "nanosec": 402223244 }, "frame_id": "map" }, "info": { "map_load_time": { "sec": 0, "nanosec": 0 }, "resolution": 0.05000000074505806, "width": 222, "height": 92, "origin": { "position": { "x": -1.149999976158142, "y": -3.6500000953674316, "z": 0.0 }, "orientation": { "x": 0.0, "y": 0.0, "z": 0.0, "w": 1.0 } } }, "data": [] }

export const DUMMY_MAP_METADATA = {
    id: DUMMY_OCCUPANCY_GRID_MSG.header.frame_id || "current_map",
    name: "Current Map",
    created_time: Date.now(),
    desc: "Live map from Aurora/Nav2",
    width: DUMMY_OCCUPANCY_GRID_MSG.info.width,
    height: DUMMY_OCCUPANCY_GRID_MSG.info.height,
    resolution: DUMMY_OCCUPANCY_GRID_MSG.info.resolution,
    origin: {
        x: DUMMY_OCCUPANCY_GRID_MSG.info.origin.position.x,
        y: DUMMY_OCCUPANCY_GRID_MSG.info.origin.position.y,
    },
    originYaw: yawFromRosOrientation(DUMMY_OCCUPANCY_GRID_MSG.info.origin.orientation),
}
